import defaultValues from './default.json';
import type { LocalisationConfigWithLang } from '../types';

const config: LocalisationConfigWithLang = {
  ...defaultValues,
  'contact.phone.number': '+33 1 80 88 80 30',
  'contact.genericForm.showInContactPanel': true,
  'contact.phone.officeHours': '1-5|09:00|19:00|Europe/Paris',
  'jobOffers.isEnabled': true,
  'apprenticeship.isEnabled': true,
  'apprenticeship.hasTalentPool': true,
  'apprenticeship.hasJobMarketPlace': true,
  'cpf.isEnabled': true,
  'franceTravail.isEnabled': true,
  'funding.isEnabled': true,
  'page.uplift.url': '/business/uplift',
  'webinar.learningExperience.url':
    'https://app.livestorm.co/openclassrooms-47/decouvrez-openclassrooms',
  'jobPostingCreation.isEnabled': true,
};

export default config;
